import { useContext } from 'react';
import { PagerContext } from '../PagerProvider';

const usePage = () => {
  const context = useContext(PagerContext);

  if (!context) {
    throw new Error(
      'use Page hook must be used in a component within the PageProvider'
    );
  }

  return context;
};

export { usePage };
